import { Component } from '@angular/core';
import { ImageBreak, THEMEDATA } from 'src/app/shared/constants/app.constants';
import { sinclairTheme } from 'src/app/shared/constants/theme.constants';
import { GlobalService } from 'src/app/shared/services/global.service';
import { UtilService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})

export class DefaultComponent {
  
  eventBreak!:ImageBreak;
  contentBreak!:ImageBreak;
  speakerBreak!:ImageBreak;
  isFirmInfo=false;
  isSinclair=false;
  constructor(private globalService: GlobalService ){}

  ngOnInit(): void {

   
    const themelist = THEMEDATA;
    this.eventBreak = ImageBreak.EventBreak;
    this.contentBreak = ImageBreak.ContentBreak;
    this.speakerBreak = ImageBreak.SpeakerBreak;
    this.globalService.jobInformation.subscribe((data) => {
    const theme = themelist.find(item => item.themeId === data.pageData.pageTheme.trim().toUpperCase());
    this.isFirmInfo = !! theme?.themeId;
    if (this.isFirmInfo) {
      this.isSinclair = theme?.themeId === sinclairTheme;
    }
    
    
  })
  }
}
